import portsApi from '@/framework/ports/portsApi';

import { DeviceSettings } from './types';

const deviceInfo = {
  getDeviceInfo: (): Promise<DeviceSettings> =>
    portsApi.invoke('DeviceDetection.getDeviceInfo'),
};

export default deviceInfo;
